module.exports = __webpack_public_path__ + "img/yuebei_bg.76a4cea0.png";